import {
    eventInfoFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/eventInfoFields.dictionary';
import {
    eventTopicFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/eventTopicFields.dictionary';
import {
    holidayFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/holidayFields.dictionary';
import {
    parentFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/parentFields.dictionary';
import {
    studentFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/studentFields.dictionary';
import {
    loginUserFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/loginUserFields.dictionary';
import {
    contractFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/contractFields.dictionary';
import {
    subjectFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/subjectFields.dictionary';
import {roomFieldsDictionary} from '@/classes/clientOnly/permissionTreeResources/dictionaries/roomFields.dictionary';
import {
    documentTypeFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/documentTypeFields.dictionary';
import {
    QualityManagementTeacherListFields,
} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/QualityManagementTeacherListFields';
import {CrudActionTypes} from '@/classes/clientOnly/permissionTreeResources/enums/CrudActionTypes';
import {
    responsibleFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/responsibleFields.dictionary';
import {
    configFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/configFields.dictionary';
import {
    customIdSchemeFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/customIdSchemeFields.dictionary';
import {statsFieldsDictionary} from '@/classes/clientOnly/permissionTreeResources/dictionaries/statsFields.dictionary';
import {
    articleFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/articleFields.dictionary';
import {
    warehouseOrderFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/warehouseOrderFields.dictionary';
import {
    storedFileFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/storedFileFields.dictionary';
import {
    invoiceTemplateFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/invoiceTemplateFields.dictionary';
import {stackFieldsDictionary} from '@/classes/clientOnly/permissionTreeResources/dictionaries/stackFields.dictionary';
import {roleFieldsDictionary} from '@/classes/clientOnly/permissionTreeResources/dictionaries/roleFields.dictionary';
import {
    storedDocumentFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/storedDocumentFields.dictionary';
import {
    bookingFormTemplateFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/bookingFormTemplateFields.dictionary';
import {
    bookingFormFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/bookingFormFields.dictionary';
import {
    onlineFormSubmissionFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/onlineFormSubmissionFields.dictionary';
import {
    invoiceDocumentFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/invoiceDocumentFields.dictionary';
import {
    recurringDocumentFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/recurringDocumentFields.dictionary';
import {
    optimizationFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/optimizationFieldsDictionary';
import {
    optimizationSuggestionFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/optimizationSuggestionFieldsDictionary';
import {jobAdFieldsDictionary} from '@/classes/clientOnly/permissionTreeResources/dictionaries/jobAdFields.dictionary';
import {
    acquisitionListFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/acquisitionListFields.dictionary';
import {
    toDoItemFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/toDoItemFields.Dictionary';
import {
    messengerAccountFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/messengerAccountFields.dictionary';
import {
    whatsAppMessageTemplateFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/whatsAppMessageTemplateFields.dictionary';
import FieldDictionary from '@/classes/clientOnly/permissionTreeResources/dictionaries/fieldDictionary';
import {
    handoutFieldsDictionary,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/handoutFields.dictionary';
import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';
import {EmployeeFields} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/EmployeeFields';
import {PaycheckFields} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/PaycheckFields';
import {
    EmployeeContractFields,
} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/EmployeeContractFields';
import {
    EmployeeContractTemplateFields,
} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/EmployeeContractTemplateFields';
import {
    OneTimeSpecialFeeFields,
} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/OneTimeSpecialFeeFields';
import {TaxonomyEntryFields} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/TaxonomyEntryFields';
import {Institution} from '@/interfaces/institution.interface';
import {Employee} from '@/interfaces/employee.interface';
import {Parent} from '@/interfaces/parent.interface';
import {Student} from '@/interfaces/student.interface';
import {Responsible} from '@/interfaces/responsible.interface';
import {FinderIndices} from '@/enums/FinderIndices';
import {WorkflowFields} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/WorkflowFields';
import {ProductFields} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/ProductFields';
import {
    ScheduledProductSeriesFields,
} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/ScheduledProductSeriesFields';
import {
    InvoiceCycleFields,
} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/InvoiceCycleFields.enum';
import {InvoiceFields} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/InvoiceFields';
import {TerminationFields} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/TerminationFields';
import {ProductOrderFields} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/ProductOrderFields';
import {
    ProductShipmentFields,
} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/ProductShipmentFields';
import {ActivityFields} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/ActivityFields';
import {CourseFields} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/CourseFields';
import {
    InstitutionActivitySignupFields,
} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/InstitutionActivitySignupFields';
import {
    HandoutEventFields,
} from '@/classes/clientOnly/permissionTreeResources/dictionaries/handoutEventFields.dictionary';
import {
    ActivityRegistrationFields,
} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/ActivityRegistrationFields';
import {
    InvoiceCycleDraftFields,
} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/InvoiceCycleDraftFields';
import {
    ProductShipmentBundleFields,
} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/ProductShipmentBundleFields';
import {
    ScheduledProductSeriesSubscriptionFields,
} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/ScheduledProductSeriesSubscriptionFields';
import {
    ApplicantsLandingPageFields,
} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/ApplicantsLandingPageFields';
import {InstitutionFields} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/InstitutionFields';
import {LogEntryFields} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/LogEntryFields';
import {VapiCallFields} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/VapiCallFields';

export enum CrudEntityTypes {
    ACTIVITY = 'activities',
    ACTIVITY_REGISTRATION = 'activityRegistrations',
    ACQUISITION_LIST = 'acquisitionLists',
    ANY_DOCUMENT = 'anyDocuments', // For create and delete of all stored documents
    API_CONFIGURATION = 'apiConfigurations',
    APPLICANTS_LANDING_PAGE = 'applicantsLandingpage',
    ARTICLE = 'articles',
    BOOKING_FORM = 'bookingForms',
    BOOKING_FORM_TEMPLATE = 'bookingFormTemplates',
    CONFIG = 'configs',
    CONTACT = 'contact',
    CONTRACT = 'contracts',
    CONVERSATION = 'conversations',
    COURSE = 'courses',
    CRON_JOB = 'cronJobs',
    CUSTOMER = 'customer',
    CUSTOMER_MAIL_TEMPLATE = 'customerMailTemplates',
    CUSTOM_ID_SCHEME = 'customIdSchemes',
    DHL_STANDING_DATA = 'dhlStandingData',
    DOCUMENT_TYPE = 'documentTypes',
    EMPLOYEE = 'employees',
    EMPLOYEE_CONTRACT = 'employeeContracts',
    EMPLOYEE_CONTRACT_TEMPLATE = 'employeeContractTemplates',
    EVENT_INFO = 'eventInfos',
    EVENT_TOPIC = 'eventTopics',
    HANDOUT = 'handouts',
    HANDOUT_EVENT = 'handoutEvents',
    HANDOUT_LIST = 'handoutLists',
    HANDOUT_LIST_ITEM = 'handoutListItems',
    HANDOUT_TEMPLATE = 'handoutTemplates', // For create and delete of handout templates
    HOLIDAY = 'holidays',
    INSTITUTION = 'institutions',
    INSTITUTION_ACTIVITY_SIGNUP = 'institutionActivitySignups',
    INVOICE = 'invoices',
    // @deprecated
    INVOICE_DOCUMENT = 'invoiceDocuments',
    // @deprecated
    INVOICE_TEMPLATE = 'invoiceTemplates',
    INVOICE_CYCLE = 'invoiceCycles',
    INVOICE_CYCLE_DRAFT = 'invoiceCycleDrafts',
    JOB_AD = 'jobAds',
    JOB_TYPE = 'jobTypes',
    LOGIN_USER = 'loginUsers',
    LOG_ENTRY = 'logEntries',
    MESSENGER_ACCOUNT = 'messengerAccounts',
    MESSENGER_MAIL = 'messengerMail',
    MESSENGER_WHATS_APP = 'messengerWhatsApp',
    NOTIFICATION = 'notifications',
    ONE_TIME_SPECIAL_FEE = 'oneTimeSpecialFees',
    ONLINE_FORM = 'onlineForms',
    ONLINE_FORM_SUBMISSION = 'onlineFormSubmissions',
    OPTIMIZATIONS = 'optimizations',
    OPTIMIZATION_SUGGESTIONS = 'optimizationSuggestions',
    OWN_DOCUMENT = 'ownDocuments', // For create and delete of own stored documents
    PARENT = 'parents',
    PAYCHECK = 'paychecks',
    PERMISSION_HOOK = 'permissionHooks',
    POST_STAMPS = 'postStamps',
    PRINTED_FORM = 'printedForms',
    PRODUCT = 'products',
    PRODUCT_ORDER = 'productOrders',
    PRODUCT_SHIPMENT = 'productShipments',
    PRODUCT_SHIPMENT_BUNDLE = 'productShipmentBundles',
    QUALITY_MANAGEMENT_TEACHER_LIST = 'qualityManagementTeacherLists',
    RECURRING_DOCUMENT = 'recurringDocuments',
    RESPONSIBLE = 'responsibles',
    ROLE = 'roles',
    ROOM = 'rooms',
    SALES_APPOINTMENT = 'salesAppointments',
    SALES_PARTNER = 'salesPartners',
    SALES_PARTNER_CHANGE = 'salesPartnerChanges',
    SALES_PARTNER_SETTINGS = 'salesPartnerSettings',
    SCHEDULED_PRODUCT_SERIES = 'scheduledProductSeries',
    SCHEDULED_PRODUCT_SERIES_SUBSCRIPTION = 'scheduledProductSeriesSubscriptions',
    SCHOOL_CLASS = 'schoolClasses',
    SHIPMENT_LABEL = 'shipmentLabels',
    SHORT_ID = 'shortIds',
    STACK = 'stacks',
    STATS = 'stats',
    STORED_DOCUMENT = 'storedDocuments', // For read and update access of stored documents
    STORED_FILE = 'storedFiles',
    STUDENT = 'students',
    SUBJECT = 'subjects',
    SUBSTITUTION_INQUIRY = 'substitutionInquiries',
    TAXONOMY_ENTRY = 'taxonomyEntries',
    TAG = 'tags',
    TERMINATION = 'terminations',
    TO_DO_ITEM = 'toDoItems',
    TO_DO_TEMPLATE = 'toDoTemplates',
    TRACKING = 'trackings',
    USER_SURVEY = 'userSurveys',
    USER_SURVEY_RESPONSE = 'userSurveyResponses',
    VAPI_ASSISTANT_INTEGRATION_CONFIG = 'vapiAssistantIntegrationConfigs',
    VAPI_CALL = 'vapiCalls',
    WAREHOUSE_ORDER = 'warehouseOrders',
    WEBHOOK = 'webhooks',
    WHATS_APP_MESSAGE_TEMPLATE = 'whatsAppMessageTemplates',
    WORKFLOW = 'workflows',
}

type FieldSpace = {
    Record: Record<string, { text: string; readOnly?: true; updateOnly?: true }>;
    Items: Array<{ value: string; text: string; readOnly?: true; updateOnly?: true }>;
}

export namespace CrudEntityTypes {
    type Data = {
        text: string;
        fieldSpace?: FieldSpace;
        actions?: CrudActionTypes[];
        fields?: FieldDictionary<string>;
        deprecated?: boolean;
    }

    export const Record: Record<CrudEntityTypes, Data> = {
        [CrudEntityTypes.ACTIVITY]: {
            text: 'Aktivitäten',
            fieldSpace: ActivityFields,
        },
        [CrudEntityTypes.ACTIVITY_REGISTRATION]: {
            text: 'Anmeldung zu einer Aktivität',
            fieldSpace: ActivityRegistrationFields,
        },
        [CrudEntityTypes.ACQUISITION_LIST]: {
            text: 'Akquiselisten',
            fields: acquisitionListFieldsDictionary,
        },
        [CrudEntityTypes.QUALITY_MANAGEMENT_TEACHER_LIST]: {
            text: 'QM-Zuständigkeiten je Bundesland',
            actions: [CrudActionTypes.READ, CrudActionTypes.CREATE, CrudActionTypes.UPDATE, CrudActionTypes.DELETE],
            fieldSpace: QualityManagementTeacherListFields,
        },
        [CrudEntityTypes.TAXONOMY_ENTRY]: {
            text: 'Taxonomie-Einträge',
            actions: [CrudActionTypes.CREATE, CrudActionTypes.UPDATE, CrudActionTypes.DELETE],
            fieldSpace: TaxonomyEntryFields,
        },
        [CrudEntityTypes.ANY_DOCUMENT]: {
            text: 'Dokumente für jede Entität',
            actions: [CrudActionTypes.CREATE, CrudActionTypes.DELETE],
        },
        [CrudEntityTypes.API_CONFIGURATION]: {
            text: 'API-Konfigurationen',
        },
        [CrudEntityTypes.APPLICANTS_LANDING_PAGE]: {
            text: 'Landingpage für Bewerber:innen',
            fieldSpace: ApplicantsLandingPageFields,
        },
        [CrudEntityTypes.ARTICLE]: {
            text: 'Produkte',
            fields: articleFieldsDictionary,
            actions: [CrudActionTypes.READ, CrudActionTypes.CREATE, CrudActionTypes.UPDATE],
        },
        [CrudEntityTypes.BOOKING_FORM]: {
            text: 'Anmeldung - Anmeldeformulare (neu)',
            fields: bookingFormFieldsDictionary,
        },
        [CrudEntityTypes.BOOKING_FORM_TEMPLATE]: {
            text: 'Anmeldung - Vorlagen für Anmeldeformulare (neu)',
            fields: bookingFormTemplateFieldsDictionary,
        },
        [CrudEntityTypes.CONFIG]: {
            text: 'Konfigurationsdatei',
            fields: configFieldsDictionary,
            actions: [CrudActionTypes.READ, CrudActionTypes.UPDATE],
        },
        [CrudEntityTypes.CONTACT]: {
            text: 'FastBill - Kontakte',
            deprecated: true,
        },
        [CrudEntityTypes.CONTRACT]: {
            text: 'Verträge (alt)',
            fields: contractFieldsDictionary,
        },
        [CrudEntityTypes.CONVERSATION]: {
            text: 'Systemkonversationen',
            fields: roleFieldsDictionary,
        },
        [CrudEntityTypes.COURSE]: {
            text: 'Kurse',
            fieldSpace: CourseFields,
        },
        [CrudEntityTypes.CRON_JOB]: {
            text: 'Automatisierungen',
        },
        [CrudEntityTypes.CUSTOM_ID_SCHEME]: {
            text: 'Referenznummern',
            fields: customIdSchemeFieldsDictionary,
        },
        [CrudEntityTypes.CUSTOMER]: {
            text: 'FastBill - Kunden',
            deprecated: true,
        },
        [CrudEntityTypes.CUSTOMER_MAIL_TEMPLATE]: {
            text: 'E-Mail-Vorlagen',
        },
        [CrudEntityTypes.DHL_STANDING_DATA]: {
            text: 'DHL Format- und Produktdaten',
        },
        [CrudEntityTypes.DOCUMENT_TYPE]: {
            text: 'Dokumenttypen',
            fields: documentTypeFieldsDictionary,
        },
        [CrudEntityTypes.EMPLOYEE]: {
            text: 'Mitarbeitende und Lehrkräfte',
            fieldSpace: EmployeeFields,
        },
        [CrudEntityTypes.EMPLOYEE_CONTRACT]: {
            text: 'Mitarbeiterverträge',
            fieldSpace: EmployeeContractFields,
        },
        [CrudEntityTypes.EMPLOYEE_CONTRACT_TEMPLATE]: {
            text: 'Vorlagen für Mitarbeiterverträge',
            fieldSpace: EmployeeContractTemplateFields,
        },
        [CrudEntityTypes.EVENT_INFO]: {
            text: 'Veranstaltungen',
            fields: eventInfoFieldsDictionary,
        },
        [CrudEntityTypes.EVENT_TOPIC]: {
            text: 'Veranstaltungsarten',
            fields: eventTopicFieldsDictionary,
        },
        [CrudEntityTypes.HANDOUT]: {
            text: 'Anmeldungen',
            fields: handoutFieldsDictionary,
            deprecated: true,
        },
        [CrudEntityTypes.HANDOUT_EVENT]: {
            text: 'Austeilaktionen',
            fieldSpace: HandoutEventFields,
        },
        [CrudEntityTypes.HANDOUT_LIST]: {
            text: 'Austeillisten',
            deprecated: true,
        },
        [CrudEntityTypes.HANDOUT_LIST_ITEM]: {
            text: 'Austeillistenelemente',
            deprecated: true,
        },
        [CrudEntityTypes.HANDOUT_TEMPLATE]: {
            text: 'Vorlagen für Anmeldungen',
            actions: [CrudActionTypes.CREATE, CrudActionTypes.DELETE],
        },
        [CrudEntityTypes.HOLIDAY]: {
            text: 'Ferien und Feiertage',
            fields: holidayFieldsDictionary,
        },
        [CrudEntityTypes.INSTITUTION]: {
            text: 'Standorte',
            fieldSpace: InstitutionFields,
        },
        [CrudEntityTypes.INSTITUTION_ACTIVITY_SIGNUP]: {
            text: 'Angebotene Standortaktivitäten',
            fieldSpace: InstitutionActivitySignupFields,
        },
        [CrudEntityTypes.INVOICE]: {
            text: 'Rechnungen',
            fieldSpace: InvoiceFields,
        },
        [CrudEntityTypes.INVOICE_CYCLE]: {
            text: 'Rechnungslauf',
            fieldSpace: InvoiceCycleFields,
        },
        [CrudEntityTypes.INVOICE_CYCLE_DRAFT]: {
            text: 'Rechnungslaufentwurf',
            fieldSpace: InvoiceCycleDraftFields,
        },
        [CrudEntityTypes.INVOICE_DOCUMENT]: {
            text: 'Rechnungen (einmalig)',
            fields: invoiceDocumentFieldsDictionary,
            deprecated: true,
        },
        [CrudEntityTypes.INVOICE_TEMPLATE]: {
            text: 'Rechnungsvorlagen',
            fields: invoiceTemplateFieldsDictionary,
            deprecated: true,
        },
        [CrudEntityTypes.JOB_AD]: {
            text: 'Stellenanzeigen',
            fields: jobAdFieldsDictionary,
        },
        [CrudEntityTypes.JOB_TYPE]: {
            text: 'Jobposition',
            actions: [CrudActionTypes.READ, CrudActionTypes.CREATE, CrudActionTypes.DELETE],
        },
        [CrudEntityTypes.LOG_ENTRY]: {
            text: 'Protokolleinträge',
            fieldSpace: LogEntryFields,
        },
        [CrudEntityTypes.LOGIN_USER]: {
            text: 'Benutzerzugänge',
            fields: loginUserFieldsDictionary,
        },
        [CrudEntityTypes.MESSENGER_ACCOUNT]: {
            text: 'Kommunikationsaccounts',
            fields: messengerAccountFieldsDictionary,
        },
        [CrudEntityTypes.MESSENGER_MAIL]: {
            text: 'E-Mails',
            actions: [CrudActionTypes.READ],
        },
        [CrudEntityTypes.MESSENGER_WHATS_APP]: {
            text: 'Whats-App-Nachrichten',
            actions: [CrudActionTypes.READ],
        },
        [CrudEntityTypes.NOTIFICATION]: {
            text: 'Benachrichtigungen',
            actions: [CrudActionTypes.READ],
        },
        [CrudEntityTypes.ONE_TIME_SPECIAL_FEE]: {
            text: 'Einmalige Sonderhonorare',
            fieldSpace: OneTimeSpecialFeeFields,
        },
        [CrudEntityTypes.ONLINE_FORM]: {
            text: 'Anmeldung - Onlinevorlagen',
            fields: onlineFormSubmissionFieldsDictionary,
        },
        [CrudEntityTypes.ONLINE_FORM_SUBMISSION]: {
            text: 'Anmeldung - Online-Anmeldungen',
            fields: onlineFormSubmissionFieldsDictionary,
        },
        [CrudEntityTypes.OPTIMIZATION_SUGGESTIONS]: {
            text: 'Optimierungsvorschläge',
            fields: optimizationSuggestionFieldsDictionary,
        },
        [CrudEntityTypes.OPTIMIZATIONS]: {
            text: 'Optimierungen',
            fields: optimizationFieldsDictionary,
        },
        [CrudEntityTypes.OWN_DOCUMENT]: {
            text: 'Eigene Dokumente',
            actions: [CrudActionTypes.CREATE, CrudActionTypes.DELETE],
        },
        [CrudEntityTypes.PARENT]: {
            text: 'Eltern',
            fields: parentFieldsDictionary,
        },
        [CrudEntityTypes.PAYCHECK]: {
            text: 'Lohnabrechnungen',
            fieldSpace: PaycheckFields,
        },
        [CrudEntityTypes.PERMISSION_HOOK]: {
            text: 'Berechtigungsroutinen',
        },
        [CrudEntityTypes.POST_STAMPS]: {
            text: 'DHL Internetmarken',
        },
        [CrudEntityTypes.PRINTED_FORM]: {
            text: 'Anmeldung - Druckvorlagen',
            fields: onlineFormSubmissionFieldsDictionary,
        },
        [CrudEntityTypes.PRODUCT]: {
            text: 'Produkte',
            fieldSpace: ProductFields,
        },
        [CrudEntityTypes.PRODUCT_ORDER]: {
            text: 'Produktbestellungen',
            fieldSpace: ProductOrderFields,
        },
        [CrudEntityTypes.PRODUCT_SHIPMENT]: {
            text: 'Produktversandaufträge',
            fieldSpace: ProductShipmentFields,
        },
        [CrudEntityTypes.PRODUCT_SHIPMENT_BUNDLE]: {
            text: 'Versandpakete',
            fieldSpace: ProductShipmentBundleFields,
        },
        [CrudEntityTypes.RECURRING_DOCUMENT]: {
            text: 'Rechnungen (wiederkehrend)',
            fields: recurringDocumentFieldsDictionary,
        },
        [CrudEntityTypes.RESPONSIBLE]: {
            text: 'Verantwortliche',
            fields: responsibleFieldsDictionary,
        },
        [CrudEntityTypes.ROLE]: {
            text: 'Benutzergruppen',
            fields: roleFieldsDictionary,
        },
        [CrudEntityTypes.ROOM]: {
            text: 'Unterrichtsräume',
            fields: roomFieldsDictionary,
        },
        [CrudEntityTypes.SALES_APPOINTMENT]: {
            text: 'Folgegespräche (Akquise)',
        },
        [CrudEntityTypes.SALES_PARTNER]: {
            text: 'Vertriebspartner',
        },
        [CrudEntityTypes.SALES_PARTNER_CHANGE]: {
            text: 'Änderungen durch Vertriebspartner',
            actions: [CrudActionTypes.READ, CrudActionTypes.UPDATE],
        },
        [CrudEntityTypes.SALES_PARTNER_SETTINGS]: {
            text: 'Einstellungen Vertriebspartner',
            actions: [CrudActionTypes.READ, CrudActionTypes.UPDATE],
        },
        [CrudEntityTypes.SCHEDULED_PRODUCT_SERIES]: {
            text: 'Geplante Produktserien',
            fieldSpace: ScheduledProductSeriesFields,
        },
        [CrudEntityTypes.SCHEDULED_PRODUCT_SERIES_SUBSCRIPTION]: {
            text: 'Abonnements für geplante Produktserien',
            fieldSpace: ScheduledProductSeriesSubscriptionFields,
        },
        [CrudEntityTypes.SCHOOL_CLASS]: {
            text: 'Schulklassen',
        },
        [CrudEntityTypes.SHIPMENT_LABEL]: {
            text: 'Versandetikette',
            fields: roleFieldsDictionary,
        },
        [CrudEntityTypes.SHORT_ID]: {
            text: 'Kurz-IDs',
        },
        [CrudEntityTypes.STACK]: {
            text: 'Stapel',
            fields: stackFieldsDictionary,
        },
        [CrudEntityTypes.STATS]: {
            text: 'Statistiken',
            actions: [CrudActionTypes.READ],
            fields: statsFieldsDictionary,
        },
        [CrudEntityTypes.STORED_DOCUMENT]: {
            text: 'Hinterlegte Dokumente',
            actions: [CrudActionTypes.READ, CrudActionTypes.UPDATE, CrudActionTypes.CREATE],
            fields: storedDocumentFieldsDictionary,
        },
        [CrudEntityTypes.STORED_FILE]: {
            text: 'Hochgeladene Dateien',
            actions: [CrudActionTypes.READ, CrudActionTypes.UPDATE, CrudActionTypes.CREATE],
            fields: storedFileFieldsDictionary,
        },
        [CrudEntityTypes.STUDENT]: {
            text: 'Schüler:innen',
            fields: studentFieldsDictionary,
        },
        [CrudEntityTypes.SUBJECT]: {
            text: 'Fächer',
            fields: subjectFieldsDictionary,
        },
        [CrudEntityTypes.SUBSTITUTION_INQUIRY]: {
            text: 'Vertretungsanfragen',
        },
        [CrudEntityTypes.TAG]: {
            text: 'Tags',
        },
        [CrudEntityTypes.TERMINATION]: {
            text: 'Kündigungen',
            fieldSpace: TerminationFields,
        },
        [CrudEntityTypes.TO_DO_ITEM]: {
            text: 'To-Dos',
            fields: toDoItemFieldsDictionary,
        },
        [CrudEntityTypes.TO_DO_TEMPLATE]: {
            text: 'To-Do-Vorlagen',
        },
        [CrudEntityTypes.TRACKING]: {
            text: 'Trackinginformationen',
        },
        [CrudEntityTypes.USER_SURVEY]: {
            text: 'Umfragen',
        },
        [CrudEntityTypes.USER_SURVEY_RESPONSE]: {
            text: 'Umfrageantworten',
            actions: [CrudActionTypes.READ, CrudActionTypes.CREATE],
        },
        [CrudEntityTypes.VAPI_ASSISTANT_INTEGRATION_CONFIG]: {
            text: 'VAPI-Assistenten-Integrationen',
        },
        [CrudEntityTypes.VAPI_CALL]: {
            text: 'VAPI-Anrufe',
            fieldSpace: VapiCallFields,
        },
        [CrudEntityTypes.WAREHOUSE_ORDER]: {
            text: 'Bestellungen',
            fields: warehouseOrderFieldsDictionary,
        },
        [CrudEntityTypes.WEBHOOK]: {
            text: 'Webhooks',
        },
        [CrudEntityTypes.WHATS_APP_MESSAGE_TEMPLATE]: {
            text: 'WhatsApp-Nachrichtenvorlagen',
            fields: whatsAppMessageTemplateFieldsDictionary,
        },
        [CrudEntityTypes.WORKFLOW]: {
            text: 'Workflows',
            fieldSpace: WorkflowFields,
        },
    }

    export const Items = mapRecordToItems(Record);
    Items.sort((a, b) => {
        if (a.deprecated) {
            return 1;
        } else if (b.deprecated) {
            return -1;
        }
        return a.text.localeCompare(b.text);
    });
    for (const item of Items) {
        if (item.fields) {
            item.fields.sort((a: { text: string }, b: { text: string }) => a.text.localeCompare(b.text));
        }
        if (item.fieldSpace) {
            const fields = item.fieldSpace.Items;
            if (fields) {
                fields.sort((a: { text: string }, b: { text: string }) => a.text.localeCompare(b.text));
            }
        }
    }

    /**
     * A union of all CrudEntityTypes representing a profile type
     */
    export type ProfileTypes =
        CrudEntityTypes.EMPLOYEE
        | CrudEntityTypes.PARENT
        | CrudEntityTypes.STUDENT
        | CrudEntityTypes.RESPONSIBLE
        | CrudEntityTypes.INSTITUTION;

    export function getProfileType(type: ProfileTypes) {
        switch (type) {
            case CrudEntityTypes.EMPLOYEE:
                return 'Mitarbeitende:r / Lehrkraft';
            case CrudEntityTypes.PARENT:
                return 'Eltern';
            case CrudEntityTypes.STUDENT:
                return 'Schüler:in';
            case CrudEntityTypes.INSTITUTION:
                return 'Standort';
            case CrudEntityTypes.RESPONSIBLE:
                return 'Ansprechpartner';
        }
    }

    export const ProfileTypesItems = [
        {
            text: 'Mitarbeitende:r / Lehrkraft',
            value: CrudEntityTypes.EMPLOYEE,
        },
        {
            text: 'Eltern',
            value: CrudEntityTypes.PARENT,
        },
        {
            text: 'Schüler:in',
            value: CrudEntityTypes.STUDENT,
        },
        {
            text: 'Ansprechpartner',
            value: CrudEntityTypes.RESPONSIBLE,
        },
    ];


    /**
     * A union of all documents that can be used as a profile
     */
    export type ProfileTypesDocuments = Employee | Parent | Student | Responsible | Institution;

    /**
     * An array of all CrudEntityTypes representing a profile type
     */
    export const ProfileTypesArray: ProfileTypes[] = [
        CrudEntityTypes.EMPLOYEE,
        CrudEntityTypes.PARENT,
        CrudEntityTypes.STUDENT,
        CrudEntityTypes.RESPONSIBLE,
        CrudEntityTypes.INSTITUTION,
    ];

    const FromFinderIndexRecord: Record<FinderIndices, CrudEntityTypes> = {
        [FinderIndices.EMPLOYEES]: CrudEntityTypes.EMPLOYEE,
        [FinderIndices.PARENTS]: CrudEntityTypes.PARENT,
        [FinderIndices.STUDENTS]: CrudEntityTypes.STUDENT,
        [FinderIndices.RESPONSIBLES]: CrudEntityTypes.RESPONSIBLE,
        [FinderIndices.ARTICLES]: CrudEntityTypes.ARTICLE,
        [FinderIndices.CONTRACTS]: CrudEntityTypes.CONTRACT,
        [FinderIndices.COURSE]: CrudEntityTypes.COURSE,
        [FinderIndices.DOCUMENT_TYPES]: CrudEntityTypes.DOCUMENT_TYPE,
        [FinderIndices.CUSTOMER_MAIL_TEMPLATES]: CrudEntityTypes.CUSTOMER_MAIL_TEMPLATE,
        [FinderIndices.JOB_ADS]: CrudEntityTypes.JOB_AD,
        [FinderIndices.INSTITUTIONS]: CrudEntityTypes.INSTITUTION,
        [FinderIndices.ROLES]: CrudEntityTypes.ROLE,
        [FinderIndices.TAGS]: CrudEntityTypes.TAG,
        [FinderIndices.INVOICE_TEMPLATES]: CrudEntityTypes.INVOICE_TEMPLATE,
        [FinderIndices.WAREHOUSE_ORDERS]: CrudEntityTypes.WAREHOUSE_ORDER,
        [FinderIndices.SUBJECTS]: CrudEntityTypes.SUBJECT,
        [FinderIndices.WHATS_APP_MESSAGE_TEMPLATES]: CrudEntityTypes.WHATS_APP_MESSAGE_TEMPLATE,
        [FinderIndices.EMPLOYEE_CONTRACT_TEMPLATES]: CrudEntityTypes.EMPLOYEE_CONTRACT_TEMPLATE,
        [FinderIndices.ROOMS]: CrudEntityTypes.ROOM,
    }

    export function fromFinderIndex(index: FinderIndices) {
        const entry = FromFinderIndexRecord[index];
        if (!entry) {
            throw new Error(`No entry found for index ${index}`);
        }
        return entry;
    }
}
